(function () {
    'use strict';

    angular
        .module('tswApp')
        .controller('InstitutionsAppController', InstitutionsAppController);

    InstitutionsAppController.$inject = ['TswAppService'];


    function InstitutionsAppController(TswAppService) {
        var vm = this;

        vm.flag                 = false;
        vm.getByFilter          = getByFilter;
        vm.loadNames            = loadNames;
        vm.loadCountries        = loadCountries;
        vm.names                = [];
        vm.countries            = [];
        vm.userSelected         = -1;
        vm.countrySelected      = -1;
        vm.has_unread_messages  = -1;
        vm.no_leads_remaining   = -1;
        vm.missing_questions    = -1;


        vm.selectOptionAll = [{
            name: '--- All ---'
        }];        

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.page         = 1;

        function activate() {
            vm.loadNames();
            vm.loadCountries();
            vm.getByFilter();
        }

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter(false);
        }

        function loadNames() {
            TswAppService.getInstitutionsNames().then(function(response) {
                vm.names = vm.selectOptionAll.concat(response);
            }).catch(function(err) {
            });
        }  

        function loadCountries() {
            TswAppService.getInstitutionsCountries().then(function(response) {
                vm.countries = vm.selectOptionAll.concat(response);
            }).catch(function(err) {
            });
        }  

        function getByFilter () {
            vm.flag         = false;
            vm.query        = {};            

            if(vm.userSelected !== -1) {
                vm.query['users_id'] = vm.userSelected.users_id;
            }

            if(vm.countrySelected !== -1) {
                vm.query['country'] = vm.countrySelected.country_id;
            }

            if(vm.has_unread_messages == true) {
                vm.query['has_unread_messages'] = true;
            }

            if(vm.no_leads_remaining == true) {
                vm.query['no_leads_remaining'] = true;
            }

            if(vm.missing_questions == true) {
                vm.query['missing_questions'] = true;
            }
            
            vm.query['page'] = vm.page;
            TswAppService.getInstitutions(vm.query).then(function(response){
                vm.institutions    = response.data;
                vm.flag             = true;
                vm.totalItems       = response.total;
                vm.to               = response.to;
                vm.itemsPerPage     = response.per_page;
                vm.setPage(response.current_page);
            }).catch(function(err) {

            });
        }

        activate();
    }

})();